// @flow
import { OptionAnswersOpinometroActionTypes } from './constants';

type OptionAnswersOpinometroAction = { type: string, payload: {} | string };

// common success
export const optionAnswersOpinometroApiResponseSuccess = (actionType: string, data: any): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const optionAnswersOpinometroApiResponseError = (actionType: string, error: string): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getOptionAnswerOpinometro = (id: string): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO,
    payload: { id },
});

export const addOptionAnswerOpinometro = (optionAnswerOpinometro: any): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO,
    payload: optionAnswerOpinometro
})
export const updateOptionAnswerOpinometro = (optionAnswerOpinometro: any): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO,
    payload: optionAnswerOpinometro
})
export const deleteOptionAnswerOpinometro = (id: string): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO,
    payload: { id }
})

export const listOptionAnswersOpinometro = (params: any): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO,
    payload: params,
});


export const resetOptionAnswersOpinometro = (): OptionAnswersOpinometroAction => ({
    type: OptionAnswersOpinometroActionTypes.RESET,
    payload: {},
});

